import React, { Component } from "react";
import { Button } from "semantic-ui-react";

import { ReportTemplate, ReportTemplateV2 } from "../../../../";

import printJS from "./print-js";

class Print extends Component {
  state = {
    isPrintLoading: false,
  };

  stopLoading = () => this.setState({ isPrintLoading: false });

  handlePrint = () => {
    return this.setState({ isPrintLoading: true }, () => {
      printJS({ printable: "header-print-button-report", type: "html", copyStyles: true, onLoadingEnd: this.stopLoading, onError: this.stopLoading });
    });
  };

  render() {
    const { isPrintLoading } = this.state;
    const { communication, settings } = this.props;

    return (
      <>
        <Button className="header-print-button bg-color" loading={isPrintLoading} onClick={() => this.handlePrint()} primary>
          {this.props.t("cc_print").message || "Print"}
        </Button>
        <div style={{ display: "none" }}>
          <div id="header-print-button-report">
            {communication.version === 2 ? (
              <ReportTemplateV2 communication={communication} settings={settings} />
            ) : (
              <ReportTemplate communication={communication} settings={settings} />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default Print;
